import {register} from './../exports/theme-sections';
import { tabs, destroyTabs } from './../exports/tabs';

const selectors = {
};

class Tabs {
  constructor(el) {
    this.init();
    // tabs(this.container);
  }
  init() {
    console.log('Tabs.init()')
  }
}

const tabsSection = {
  onLoad() {
    // new Tabs(this.container);
    tabs(this.container);
  },
};

register('tabs', [tabsSection]);
